
























































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";

// Enums
import { DataModules } from "@/store/modules/data";
import { ActionTypes } from "@/data/enums";
import { PhoneTypes } from "@/data/status";

// Types
import { IClient, IClientPhoneForm } from "@/models/clients";
import { IState } from "@/store";
import { ICountry } from "@/models/constants";
import { IPhone } from "@/models/phones";
import { CountryCode } from "libphonenumber-js/types";

@Component({
  components: {
    "phone-number-field": () =>
      import("@/components/app/global/fields/phoneNumberField.vue")
  },
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${DataModules.CLIENTS_PHONES}/clientScope`](
          this.clientId
        );
      },
      params(state: IState, getters) {
        return getters[`data/${DataModules.CLIENTS_PHONES}/params`](
          this.clientId
        );
      },
      brandCountryId: (state: IState) => state.brand.country_id
    })
  }
})
export default class AddEditClientPhoneModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Props

  @Prop({ default: null })
  public data: any;

  @Prop({ default: "" })
  public phoneId!: IPhone["id"];

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public countryCode!: CountryCode;

  @Prop({ default: "create" })
  public actionType!: string;

  // Vuex Bindings

  public dataScope!: string;
  public params!: object;
  public brandCountryId!: ICountry["id"];

  // Data

  public form: IClientPhoneForm = {
    phone: null,
    phone_code: null,
    phone_country_code: null,
    type: 1
  };
  public formClone: IClientPhoneForm | any = {};
  public isProcessing = false;
  public isLoading = true;
  public phoneTypes: any = this.$_.clone(PhoneTypes);

  public created() {
    if (this.actionType !== ActionTypes.CREATE) {
      this.form = this.$_.merge({}, this.form, this.data);
      this.formClone = this.$_.clone(this.form);
    }
    this.isLoading = false;
  }

  public onPhoneChange(value) {
    this.form.phone_code = value.phone_code;
    this.form.phone = value.phone;
    this.form.phone_country_code = value.phone_country_code;
  }

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      // Create or Update Phone
      this.actionType === ActionTypes.CREATE
        ? await this.createPhone()
        : await this.updatePhone();
      // Refresh list (if applicable)
      if (!this.$_.isEmpty(this.params)) await this.refreshList();
      // Emit event(s)
      this.$emit("success", true);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  private async createPhone() {
    // Add phone number
    await this.$store.dispatch(`data/${DataModules.CLIENTS_PHONES}/create`, {
      id: this.clientId,
      data: this.form
    });
    // Open success toast
    await this.$store.dispatch("toast/show", {
      message: this.$t("_.object_successfully_added", {
        object: this.$t("_.phone")
      })
    });
  }

  private async updatePhone() {
    // Update phone number
    await this.$store.dispatch(`data/${DataModules.CLIENTS_PHONES}/update`, {
      id: this.clientId,
      phone_id: this.phoneId,
      data: this.form
    });
    // Open success toast
    await this.$store.dispatch("toast/show", {
      message: this.$t("_.object_successfully_updated", {
        object: this.$t("_.phone")
      })
    });
  }

  @Watch("form.phone_country_code")
  public onCountryCodeChange() {
    this.$refs.observer.reset();
  }

  public get formIsValid() {
    let allFieldsValid = true;

    if (this.actionType === ActionTypes.CREATE) {
      if (
        this.$_.isEmpty(this.form.phone) ||
        this.$_.isEmpty(this.form.phone_code) ||
        this.$_.isEmpty(this.form.phone_country_code)
      ) {
        return false;
      }
    } else if (this.$_.isEqual(this.form, this.formClone)) {
      allFieldsValid = false;
    }

    return allFieldsValid;
  }

  public get formIsDisabled() {
    return (
      this.isProcessing || !this.formIsValid || this.hasErrors || this.isLoading
    );
  }

  public getNewValues() {
    return this.$_.omitBy(this.form, (v, k) => {
      return this.formClone[k] === v;
    });
  }

  public async refreshList() {
    await this.$store.dispatch(`data/${DataModules.CLIENTS_PHONES}/list`, {
      id: this.clientId,
      params: this.params,
      scope: this.dataScope,
      ignoreStored: true,
      vm: this
    });

    await this.$store.dispatch("data/binList", {
      storeModule: DataModules.CLIENTS_PHONES,
      scope: this.dataScope,
      vm: this
    });
  }
}
